import Contact from './Contact';

export default Contact;

export { ContactImage } from './ContactImage';
